/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-04-08 09:47:19
 */
export const preventRepeatClick = (Vue) => {
  Vue.directive('preventRepeatClick', {
    inserted: function (el, binding) {
      el.addEventListener('click', () => {
        if (!el.disabled) {
          el.disabled = true
          setTimeout(() => {
            el.disabled = false
          }, binding.value || 3000)
        }
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/directives/index.js